import { useRouter, type ErrorComponentProps } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { PageLayout } from "@/components/ui";
import { Text } from "@blycare/polar-ui";

export function RoutePageError({ error, reset }: ErrorComponentProps) {
  const router = useRouter();

  return (
    <PageError
      error={error}
      onRetry={() => {
        reset();
        void router.invalidate();
      }}
    />
  );
}

export function PageError({ error, onRetry }: { error: Error; onRetry: () => void }) {
  const { t } = useTranslation();
  return (
    <PageLayout heading="BlyCare">
      <s-section>
        <s-stack gap="small-100">
          <s-stack gap="small-400" direction="inline">
            <s-icon type="alert-circle" tone="critical" />
            <Text as="span" variant="headingMd">
              {error?.message}
            </Text>
          </s-stack>
          <s-button onClick={onRetry} variant="primary">
            {t("TryAgain")}
          </s-button>
        </s-stack>
      </s-section>
    </PageLayout>
  );
}
